import React from 'react';

import { Control, Errors } from 'react-redux-form';
import { FormattedMessage } from 'react-intl';

import { Field } from 'common/components/forms';
import Button from 'common/components/button';

export const EmailField = ({
  formatMessage,
  emailAddressMessage,
  emailAddress,
}) => <Field label={formatMessage(emailAddressMessage)}>
  <Control.input
    type='email'
    model='signUp.email'
    validators={{ isEmail: HfReactHelper.isValidEmailAddress }}
    value={emailAddress || ''}
    data-qa-ref="email_sign_up_input" />
  <Errors
    model='signUp.email'
    show='touched'
    messages={{ isEmail: <FormattedMessage id='' defaultMessage='Please enter a valid email address' description='sign up page' /> }}
    className='m-field--error' />
</Field>;

export const InviteText = ({ teamInviteSenderEmail, domain, emailAddress }) => <div>
  <p className='l-margin-v-20'>
    <FormattedMessage
      id=''
      defaultMessage="You've been invited by {teamInvitedSenderEmail} to join their team on {domain}"
      description='sign up page'
      values={{ teamInvitedSenderEmail: <strong>{teamInviteSenderEmail}</strong>, domain }} />
  </p>
  <p className='l-margin-v-20'>
    <FormattedMessage
      id=''
      defaultMessage="If you accept, we'll create an account for you with the email address {emailAddress} and add you to the team automatically."
      description='sign up page'
      values={{ emailAddress: <strong>{emailAddress}</strong> }} />
  </p>
</div>;

export const SignupButton = ({ isInvite, pending, siteCodeString }) => <Button
  buttonText={
    isInvite
      ? <FormattedMessage id='' defaultMessage='Sign up and join team' description='sign up page' />
      : <FormattedMessage id='' defaultMessage='Create an account' description='sign up page' />
  }
  buttonColor='cerulean'
  type='submit'
  disabled={pending}
  buttonAttrs={
      {
        'data-qa-ref': 'login-button-after-password',
        'da-category': 'signup',
        'da-action': `create account inapp - ${siteCodeString}`,
        'da-label': 'create an account',
      }
  } />;
